import { API } from 'aws-amplify';
import Auth from '@aws-amplify/auth';
import { apiKey } from '../constants';
import { orderfulApi } from 'services/api-instances';
import {
  FORCE_ORDER_STATUS_FETCHING,
  FORCE_ORDER_STATUS_SUCCESS,
  FORCE_ORDER_STATUS_FAILURE,
  FORCE_ORDER_EIRCODE_FETCHING,
  FORCE_ORDER_EIRCODE_SUCCESS,
  FORCE_ORDER_EIRCODE_FAILURE,
  FORCE_ORDER_MISSION_NULL_FETCHING,
  FORCE_ORDER_MISSION_NULL_SUCCESS,
  FORCE_ORDER_MISSION_NULL_FAILURE,
  GRID_DATA_RECEIVED,
  API_ERROR,
  API_DATA_REQUESTED,
  COMPLETE_MISSION_FETCHING,
  COMPLETE_MISSION_SUCCESS,
  COMPLETE_MISSION_FAILURE
} from './actionTypes';
import Axios from 'axios';
import { parseFlightRoutes } from 'views/DevTools/tools';
import { getLatestJwtToken } from 'services/amplify-auth';
const getOptions = async () => {
  return {
    headers: {
      'x-api-key': apiKey,
      Authorization: `Bearer ${await getLatestJwtToken()}`
    }
  };
};

const forceOrderStatusFetching = () => {
  return { type: FORCE_ORDER_STATUS_FETCHING };
};
const forceOrderStatusSuccess = () => {
  return { type: FORCE_ORDER_STATUS_SUCCESS };
};
const forceOrderStatusFailure = () => {
  return { type: FORCE_ORDER_STATUS_FAILURE };
};

export const postForceOrderStatusThunk = (orderId, status) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(forceOrderStatusFetching());
    const res = await API.post(
      'api',
      `/dev/forceOrderStatus?orderId=${orderId}&status=${status}`,
      {},
      await getOptions()
    );
    dispatch(forceOrderStatusSuccess(res));
  } catch (err) {
    dispatch({
      type: API_ERROR,
      payload: err
    });
    dispatch(forceOrderStatusFailure());
    throw err;
  }
};
const forceOrderEircodeFetching = () => {
  return { type: FORCE_ORDER_EIRCODE_FETCHING };
};
const forceOrderEircodeSuccess = () => {
  return { type: FORCE_ORDER_EIRCODE_SUCCESS };
};
const forceOrderEircodeFailure = () => {
  return { type: FORCE_ORDER_EIRCODE_FAILURE };
};

export const forceOrderEircodeThunk = (orderId, eircode) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(forceOrderEircodeFetching());
    const res = await orderfulApi.forceUpdateLocationIdOnOrder(orderId, eircode);
    dispatch(forceOrderEircodeSuccess(res));
  } catch (err) {
    dispatch(forceOrderEircodeFailure());
    dispatch({
      type: API_ERROR,
      payload: err
    });
    throw err;
  }
};
const forceOrderMissionNullFetching = () => {
  return { type: FORCE_ORDER_MISSION_NULL_FETCHING };
};
const forceOrderMissionNullSuccess = () => {
  return { type: FORCE_ORDER_MISSION_NULL_SUCCESS };
};
const forceOrderMissionNullFailure = () => {
  return { type: FORCE_ORDER_MISSION_NULL_FAILURE };
};

export const forceOrderMissionNullThunk = (orderId, missionId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch(forceOrderMissionNullFetching());
    const res = await API.post(
      'api',
      `/mission/remove/${orderId}/${missionId}`,
      {},
      await getOptions()
    );
    dispatch(forceOrderMissionNullSuccess(res));
  } catch (err) {
    dispatch(forceOrderMissionNullFailure());
    dispatch({
      type: API_ERROR,
      payload: err
    });
    throw err;
  }
};

const completeMissionFetching = () => {
  return { type: COMPLETE_MISSION_FETCHING };
};
const completeMissionSuccess = () => {
  return {
    type: COMPLETE_MISSION_SUCCESS,
    meta: { success: { message: `Mission status set to COMPLETED` } }
  };
};
const completeMissionFailure = err => {
  return { type: COMPLETE_MISSION_FAILURE, meta: { error: err } };
};

export const completeMissionAirspace = missionId => async (
  dispatch,
  getState
) => {
  try {
    dispatch(completeMissionFetching());
    const res = await API.post(
      'api',
      `/mission/updateStatus?missionId=${missionId}&status=COMPLETED`,
      {},
      await getOptions()
    );
    dispatch(completeMissionSuccess(res));
  } catch (err) {
    dispatch(completeMissionFailure(err));

    throw err;
  }
};

export const fetchAirspace = () => async (dispatch, getState) => {
  try {
    dispatch({ type: API_DATA_REQUESTED });
    const res = await Axios.get(
      `${process.env.REACT_APP_MANNA_CORE_API_HOST}/airspace/view?latitude=53.269837&longitude=-8.931032`,
      await getOptions()
    );
    const missions = parseFlightRoutes(res.data);

    dispatch({
      type: GRID_DATA_RECEIVED,
      payload: missions
    });
  } catch (err) {
    dispatch({
      type: API_ERROR,
      payload: err
    });
    throw err;
  }
};
